import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PotentialPromotionsComponent } from './potential-promotions.component';

@NgModule({
  declarations: [PotentialPromotionsComponent],
  exports: [PotentialPromotionsComponent],
  imports: [CommonModule, MatIconModule],
})
export class PotentialPromotionsModule {}
